/**
 * @generated SignedSource<<9ab9cf85eee5fdfaf1daaa3f3437b85d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FavoritesItemProvider_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useFavoritesItem_user">;
  readonly " $fragmentType": "FavoritesItemProvider_user";
};
export type FavoritesItemProvider_user$key = {
  readonly " $data"?: FavoritesItemProvider_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"FavoritesItemProvider_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FavoritesItemProvider_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFavoritesItem_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e48af646d1688803fa9a2c07a54297d1";

export default node;
